import chroma from 'chroma-js';

const BRIGHTENING_STEP = 0.17;
const getShadeColors = (colorHex: string, index: number): string => {
  const shade = chroma(colorHex).brighten(BRIGHTENING_STEP * index);
  return shade.hex();
};

export default getShadeColors;
